export default __webpack_public_path__ + "static/media/aahpmPosterImg.6eceb99b.png";